// extracted by mini-css-extract-plugin
export default {"ErrorBox":"errorBox_ErrorBox__Gd6Qi"};